import { Close, Lightbulb } from '@mui/icons-material';
import { Box, Divider, Grid, IconButton, LinearProgress, Paper, Tooltip, Typography } from '@mui/material';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Api from "../../customlib/Api";
import Global from "../../customlib/Global";
import axios from "axios";
import FuBlastTeleSetting from './Features/FuBlastTeleSetting';
import FuBlastTeleAllSetting from './Features/FuBlastTeleAllSetting';
import FuBlastTeleRBSetting from './Features/FuBlastTeleRBSetting';
import AutoReplySalesOnline from './Features/AutoReplySalesOnline';

class FeaturesSettings extends Component {
    state = { 
        generalSettings: null,
        isLoading: false
    } 

    loadGeneralSettings = () => {
        this.setState({isLoading: true}, () => {
            axios
                .get(Api.getGeneralSettings(), Api.getRequestHeader())
                .then((response) => {
            
                    console.log("GENERAL_SSETTINGS", response.data);
                
                    var data = response.data;
                
                    this.setState({generalSettings: data.data, isLoading: false});
            
                })
                .catch((error) => {
                    this.setState({isLoading: false});
                    console.error("There was an error!", error);
                });
        });
        

    }

    componentDidMount() {
        this.loadGeneralSettings();
    }

    render() { 
        return (
            <Paper sx={{padding: "20px", margin: "10px"}}>
                <Box>
                    <Grid container spacing={1}>
                        <Grid item sm={11}>
                            <Typography variant='h5'>Features Settings</Typography>
                        </Grid> 
                        <Grid item sm={1} textAlign={"right"}>
                            <Tooltip title="Features Settings">
                                <Link to="/">
                                    <IconButton color='error'>
                                        <Close  />
                                    </IconButton>
                                </Link>
                            </Tooltip>
                        </Grid> 
                    </Grid>
                </Box>
                <Divider />
                {
                    this.state.isLoading && (
                        <LinearProgress />
                    )
                }
                {
                    this.state.generalSettings && (
                        <Box sx={{mt: "20px"}}>
                            <Grid container spacing={1}>
                                <Grid item sm={4} xs={12}>
                                    <FuBlastTeleSetting data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>
                                <Grid item sm={4} xs={12}>
                                    <FuBlastTeleAllSetting data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>
                                <Grid item sm={4} xs={12}>
                                    <FuBlastTeleRBSetting data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>
                                <Grid item sm={4} xs={12}>
                                    <AutoReplySalesOnline data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>
                            </Grid>
                        </Box>
                    )
                }
                
            </Paper>
        );
    }
}
 
export default FeaturesSettings;